<div class="summary-box__list-wrapper">
  <ul class="summary-box__list">
    <li *ngFor="let summary of items">
      <summary-item [summary]="summary"></summary-item>
    </li>
  </ul>
</div>
